/**
 * @file returns meta info about city
 */

const cities = {
    berlin: {
        name: 'Berlin',
        center: [52.518528, 13.405057],
        numberOfRides: 8678
    },
    seattle: {
        name: 'Seattle',
        center: [47.606204, -122.334085],
        numberOfRides: 8166
    },
    brussels: {
        name: 'Brussels',
        center: [50.85, 4.35],
        numberOfRides: 9606
    }
}

export default function (city) {
    const cityInfo = cities[city];
    if (cityInfo) {
        const {name, numberOfRides} = cityInfo;
        const title = `${name} – Strava Activities Map`;
        const description = `Mapping ${
            numberOfRides
        } bicycle rides from May 2017 in ${
            name
        }`;
        const descriptionShort = `Mapping ${
            numberOfRides
        } bicycle rides from May 2017`;
        Object.assign(cityInfo, {title, description, descriptionShort});
    }
    return cityInfo;
}



// WEBPACK FOOTER //
// ./src/lib/getCityInfo.js